import {
  FormsModule,
  NonNullableFormBuilder,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { SubSink } from 'subsink';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
  signal,
} from '@angular/core';
import { ResetPasswordService } from '@frontdoor/app/services/reset-password.service';
import { SupportButtonComponent } from '@shared/lib/components/support-button/support-button.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'ba-forgot-credentials',
  templateUrl: './forgot-credentials.component.html',
  styleUrls: ['./forgot-credentials.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    SupportButtonComponent,
    MatProgressSpinnerModule,
  ],
})
export class ForgotCredentialsComponent implements OnInit, OnDestroy {
  private _subs = new SubSink();
  readonly email = this._fb.control<string>('', [
    Validators.required,
    Validators.email,
  ]);
  readonly isBusy = signal(false);
  constructor(
    private readonly _fb: NonNullableFormBuilder,
    protected readonly _resetPasswordService: ResetPasswordService
  ) {}

  ngOnInit(): void {
    this._resetPasswordService.resetPasswordStatus.set({
      type: null,
      message: '',
    });
  }

  async onForgotPassword() {
    if (this.email.valid && !this.isBusy()) {
      this.isBusy.set(true);
      this._subs.sink = this._resetPasswordService
        .requestForgetPassword(this.email.value)
        .subscribe({
          next: () => this.isBusy.set(false),
          error: () => this.isBusy.set(false),
        });
    }
  }
  onForgotUsername() {
    if (this.email.valid && !this.isBusy()) {
      this.isBusy.set(true);
      this._subs.sink = this._resetPasswordService
        .requestForgetUsername(this.email.value)
        .subscribe({
          next: () => this.isBusy.set(false),
          error: () => this.isBusy.set(false),
        });
    }
  }
  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }
}
